<template>
    <v-container>
        <v-row>
            <v-spacer></v-spacer>
            <v-col cols="11" sm="11" md="11" style="margin-left: 10px;">
                <v-select v-model="selectedChart" :items="charts" label="Select Chart" 
                item-text="name"
                item-value="value" multiple chips>
                </v-select>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-row v-if="show.c1">
            <v-col cols="12">
                <v-card class="d-inline-block ma-1" width="70%" outlined>
                    <v-card-title class="justify-center"><h4>กราฟแสดงพฤติกรรมการนัดหมายสมาชิก <br> ของกลุ่มงาน xxx <br> ช่วงระหว่างวันที่ xxx ถึงวันที่ xxx  </h4></v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle>
                        <v-row>
                        <v-col>
                            <DatePicker label='ตั้งแต่วันที่' :date='startDate'></DatePicker>
                        </v-col>
                        <v-col>
                            <DatePicker label='ถึงวันที่' :date='startDate'></DatePicker>
                        </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    small-chips
                                    chips
                                    placeholder="เลือกกลุ่มของสมาชิก"
                                    label="กลุ่ม"
                                    multiple
                                    :items="groups">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <LineChart :data="lineData1"></LineChart>
                </v-card>
            </v-col>
        </v-row>
<v-divider></v-divider>
         <v-row v-if="show.c2">
            <v-col cols="12">
                <v-card class="d-inline-block ma-1" width="70%" outlined>
                    <v-card-title class="justify-center"><h4>กราฟแสดงสัดส่วนพฤติกรรมการนัดหมายสมาชิก <br> ของกลุ่มงาน xxx <br> ช่วงระหว่างวันที่ xxx ถึงวันที่ xxx  </h4></v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle>
                        <v-row>
                        <v-col>
                            <DatePicker label='ตั้งแต่วันที่' :date='startDate'></DatePicker>
                        </v-col>
                        <v-col>
                            <DatePicker label='ถึงวันที่' :date='startDate'></DatePicker>
                        </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    small-chips
                                    chips
                                    placeholder="เลือกกลุ่มของสมาชิก"
                                    label="กลุ่ม"
                                    multiple
                                    :items="groups">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <LineChart :data="lineData2"></LineChart>
                </v-card>
            </v-col>
        </v-row>
<v-divider></v-divider>
         <v-row v-if="show.c3">
            <v-col cols="12">
                <v-card class="d-inline-block ma-1" width="70%" outlined>
                    <v-card-title class="justify-center"><h4>พฤติกรรมของสมาชิกแยกตามวันในสัปดาห์ <br> ของกลุ่มงาน xxx <br> ช่วงระหว่างวันที่ xxx ถึงวันที่ xxx  </h4></v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle>
                        <v-row>
                        <v-col>
                            <DatePicker label='ตั้งแต่วันที่' :date='startDate'></DatePicker>
                        </v-col>
                        <v-col>
                            <DatePicker label='ถึงวันที่' :date='startDate'></DatePicker>
                        </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    small-chips
                                    chips
                                    placeholder="เลือกกลุ่มของสมาชิก"
                                    label="กลุ่ม"
                                    multiple
                                    :items="groups">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <LineChart :data="lineData3"></LineChart>
                </v-card>
            </v-col>
        </v-row>
<v-divider></v-divider>

        <v-row v-if="show.c4">
            <v-col cols="12">
                <v-card class="d-inline-block ma-1" width="50%" outlined>
                    <v-card-title class="justify-center"><h4>แนวโน้มพฤติกรรมไม่ตอบสนองนัด vs รับผิดชอบต่อนัด <br> ของกลุ่มงาน xxx <br> ช่วงระหว่างวันที่ xxx ถึงวันที่ xxx  </h4></v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle>
                        <v-row>
                        <v-col>
                            <DatePicker label='ตั้งแต่วันที่' :date='startDate'></DatePicker>
                        </v-col>
                        <v-col>
                            <DatePicker label='ถึงวันที่' :date='startDate'></DatePicker>
                        </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    small-chips
                                    chips
                                    placeholder="เลือกกลุ่มของสมาชิก"
                                    label="กลุ่ม"
                                    multiple
                                    :items="groups">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <LineChart :data="lineData4"></LineChart>
                </v-card>
            </v-col>
        </v-row>
<v-divider></v-divider>

         <v-row v-if="show.c5">
            <v-col cols="12">
                <v-card class="d-inline-block ma-1" width="50%" outlined>
                    <v-card-title class="justify-center"><h4>กราฟแสดงความเปลี่ยนแปลงรายเดือนของสมาชิกไม่มาตามนัด <br> ของกลุ่มงาน xxx <br> ตั้งแต่เดือน xxx ถึงวันที่ xxx  </h4></v-card-title>
                    <v-divider></v-divider>
                    <v-card-subtitle>
                        <v-row>
                        <v-col>
                            <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date"
                            label="ตั้งแต่เดือน"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        type="month"
                        no-title
                        :show-current="false"
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
                        </v-col>
                        <v-col>
                            <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="dateTo"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateTo"
                            label="ถึงเดือน"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="dateTo"
                        type="month"
                        no-title
                        :show-current="false"
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu2 = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(dateTo)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
                        </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    small-chips
                                    chips
                                    placeholder="เลือกกลุ่มของสมาชิก"
                                    label="กลุ่ม"
                                    multiple
                                    :items="groups">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                    <v-divider></v-divider>
                    <LineChart :data="lineData5" :options="barOption"></LineChart>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DatePicker from '@/components/Common/DatePicker.vue'
import LineChart from './LineChart'
import Constant from '@/model/utils/Constants.js'

export default {
    components: {
        DatePicker,
        LineChart
    },
    watch: {
        selectedChart: function(newVal) {
            this.show = Object.assign({}, this.defaultItem);
            newVal.forEach(element => {
                switch(element) {
                    case 0: this.show.c1 = true; break;
                    case 1: this.show.c2 = true; break;
                    case 2: this.show.c3 = true; break;
                    case 3: this.show.c4 = true; break;
                    case 4: this.show.c5 = true; break;
                }
            });
        }
    },
    data: () => ({
        date: new Date().toISOString().substr(0, 7),
        dateTo: new Date().toISOString().substr(0, 7),
        menu: false,
        menu2: false,
        groups: Constant.groups,
        show: {c1: true, c2: false, c3: false, c4: false},
        startDate: new Date().toISOString().substr(0, 10),
        lineData1: null,
        lineData2: null,
        lineData3: null,
        charts: [
            {name: 'กราฟแสดงพฤติกรรมการนัดหมายสมาชิก', value: 0},
            {name: 'กราฟแสดงสัดส่วนพฤติกรรมการนัดหมายสมาชิก', value: 1},
            {name: 'พฤติกรรมของสมาชิกแยกตามวันในสัปดาห์', value: 2},
            {name: 'แนวโน้มพฤติกรรมไม่ตอบสนองนัด vs รับผิดชอบต่อนัด', value: 3},
            {name: 'กราฟแสดงความเปลี่ยนแปลงรายเดือนของสมาชิกที่ไม่มาตามนัด', value: 4}
        ],
        selectedChart: [0],
        barOption: {
            legend: { display: false }
        }
    }),
    methods: {
        fillBarData() {
              this.barData = {
                labels: ['กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม'],
                datasets: [
                    {
                        backgroundColor: '#4351cb',
                        data: [
                            10, 2, 12, 1, 4, 5, 6
                        ]
                    }
                    ]
            }
        },
        fillPieData() {
            this.pieData = {
                labels: ['จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์', 'อาทิตย์'],
                datasets: [
                    {
                        label: '50',
                        backgroundColor: ['#69da63', '#e5cd6f', '#d2f316', '#f33558', 'green', 'blue', 'red'],
                        data: [
                            5, 10, 15, 20, 15, 15, 5
                        ]
                    }
                    ]
            }
        },
        fillLineData() {
            this.lineData1 = {
                labels: ['01/03/2021', '02/03/2021', '03/03/2021', '04/03/2021', '05/03/2021', '06/03/2021', '07/03/2021'],
                datasets: [
                    {
                        label: 'จำนวนคนปฏิเสธนัด',
                        pointBackgroundColor: '#69da63',
                        borderColor: '#69da63',
                        borderWidth: 1,
                        pointBorderColor: '#69da63',
                        backgroundColor: 'transparent',
                        data: [
                            10, 2, 12, 1, 12, 4, 8
                        ]
                    },
                    {
                        label: 'จำนวนคนไม่มาตามนัด',
                        pointBackgroundColor: 'blue',
                        borderColor: 'blue',
                        borderWidth: 1,
                        pointBorderColor: 'blue',
                        backgroundColor: 'transparent',
                        data: [
                            5, 7, 2, 4,  12, 1, 1
                        ]
                    },
                    {
                        label: 'จำนวนคนมาสาย',
                        pointBackgroundColor: '#a3f907',
                        borderColor: '#a3f907',
                        borderWidth: 1,
                        pointBorderColor: '#a3f907',
                        backgroundColor: 'transparent',
                        data: [
                            1, 12, 4, 8,  5, 7, 2
                        ]
                    },
                    {
                        label: 'จำนวนคนมาก่อนเวลา',
                        pointBackgroundColor: '#d2f316',
                        borderColor: '#d2f316',
                        borderWidth: 1,
                        pointBorderColor: '#d2f316',
                        backgroundColor: 'transparent',
                        data: [
                            1, 5, 7, 2,  1, 5, 4
                        ]
                    },
                    {
                        label: 'จำนวนคนมาตรงเวลา',
                        pointBackgroundColor: 'green',
                        borderColor: 'green',
                        borderWidth: 1,
                        pointBorderColor: 'green',
                        backgroundColor: 'transparent',
                        data: [
                            5, 10, 15, 15, 15, 15, 5
                        ]
                    }
                ]
            }
            this.lineData2 = {
                labels: ['01/03/2021', '02/03/2021', '03/03/2021', '04/03/2021', '05/03/2021', '06/03/2021', '07/03/2021'],
                datasets: [
                    {
                        label: 'จำนวนคนปฏิเสธนัด',
                        pointBackgroundColor: '#69da63',
                        borderColor: '#69da63',
                        borderWidth: 1,
                        pointBorderColor: '#69da63',
                        backgroundColor: 'transparent',
                        data: [
                            10, 20, 5, 15, 30, 18, 12
                        ]
                    },
                    {
                        label: 'จำนวนคนไม่มาตามนัด',
                        pointBackgroundColor: 'blue',
                        borderColor: 'blue',
                        borderWidth: 1,
                        pointBorderColor: 'blue',
                        backgroundColor: 'transparent',
                        data: [
                            30, 18, 12,  10, 20, 5, 10
                        ]
                    },
                    {
                        label: 'จำนวนคนมาสาย',
                        pointBackgroundColor: '#e3f907',
                        borderColor: '#e3f907',
                        borderWidth: 1,
                        pointBorderColor: '#e3f907',
                        backgroundColor: 'transparent',
                        data: [
                            10, 20, 5, 10, 20, 5, 20
                        ]
                    },
                    {
                        label: 'จำนวนคนมาก่อนเวลา',
                        pointBackgroundColor: '#d2f316',
                        borderColor: '#d2f316',
                        borderWidth: 1,
                        pointBorderColor: '#d2f316',
                        backgroundColor: 'transparent',
                        data: [
                            7, 2,  10, 23,  10, 20, 5
                        ]
                    },
                    {
                        label: 'จำนวนคนมาตรงเวลา',
                        pointBackgroundColor: 'green',
                        borderColor: 'green',
                        borderWidth: 1,
                        pointBorderColor: 'green',
                        backgroundColor: 'transparent',
                        data: [
                            5, 10, 15, 20, 15, 15, 5
                        ]
                    }
                ]
            }

            this.lineData3 = {
                labels: ['จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์', 'อาทิตย์'],
                datasets: [
                    {
                        label: 'จำนวนไม่มา',
                        pointBackgroundColor: '#69da63',
                        borderColor: '#69da63',
                        borderWidth: 1,
                        pointBorderColor: '#69da63',
                        backgroundColor: 'transparent',
                        data: [
                            10, 20, 5, 15, 30, 18, 12
                        ]
                    },
                    {
                        label: 'จำนวนสาย',
                        pointBackgroundColor: 'blue',
                        borderColor: 'blue',
                        borderWidth: 1,
                        pointBorderColor: 'blue',
                        backgroundColor: 'transparent',
                        data: [
                            30, 18, 12,  10, 20, 5, 10
                        ]
                    },
                    {
                        label: 'จำนวนมาก่อนเวลา',
                        pointBackgroundColor: '#e3f907',
                        borderColor: '#e3f907',
                        borderWidth: 1,
                        pointBorderColor: '#e3f907',
                        backgroundColor: 'transparent',
                        data: [
                            10, 20, 5, 10, 20, 5, 20
                        ]
                    },
                    {
                        label: 'จำนวนคนตรงเวลา',
                        pointBackgroundColor: 'pink',
                        borderColor: 'pink',
                        borderWidth: 1,
                        pointBorderColor: 'pink',
                        backgroundColor: 'transparent',
                        data: [
                            7, 2,  10, 23,  10, 20, 5
                        ]
                    }
                ]
            }

            this.lineData4 = {
                labels: ['01/03/2021', '02/03/2021', '03/03/2021', '04/03/2021', '05/03/2021', '06/03/2021', '07/03/2021'],
                datasets: [
                    {
                        label: 'ไม่มา',
                        pointBackgroundColor: 'blue',
                        borderColor: 'blue',
                        borderWidth: 1,
                        pointBorderColor: 'blue',
                        backgroundColor: 'transparent',
                        data: [
                            5, 7, 2, 4,  12, 1, 1
                        ]
                    },
                    {
                        label: 'แจ้งยกเลิกนัด',
                        pointBackgroundColor: 'green',
                        borderColor: 'green',
                        borderWidth: 1,
                        pointBorderColor: 'green',
                        backgroundColor: 'transparent',
                        data: [
                            5, 10, 15, 15, 15, 15, 5
                        ]
                    }
                ]
            }
            this.lineData5 = {
                labels: ['กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม'],
                datasets: [
                    {
                        label: 'จำนวนคนไม่มาตามนัด',
                        pointBackgroundColor: 'blue',
                        borderColor: 'blue',
                        borderWidth: 1,
                        pointBorderColor: 'blue',
                        backgroundColor: 'transparent',
                        data: [
                            5, 7, 2, 4,  12, 1, 1
                        ]
                    },
                    {
                        label: 'จำนวนคนปฏิเสธนัด',
                        pointBackgroundColor: 'green',
                        borderColor: 'green',
                        borderWidth: 1,
                        pointBorderColor: 'green',
                        backgroundColor: 'transparent',
                        data: [
                            5, 10, 15, 15, 15, 15, 5
                        ]
                    }
                ]
            }
        },
    },
    created() {
        this.fillLineData();
    }
}
</script>